import { ReactElement, useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopHeader from './TopHeader';
import MenuBar from './MenuBar';
import { Toaster } from 'react-hot-toast';
import StatusBar from 'components/StatusBar';

export default function MainLayout(props: { signOut: any }): ReactElement {
  const { signOut } = props;

  const [showSideBar, setShowSideBar] = useState<boolean>(true);
  const [showMobileSideBar, setMobileSideBar] = useState<boolean>(false);

  const toggleSideBar = (): void => {
    setShowSideBar(!showSideBar);
  };

  const toggleMobileSideBar = (): void => {
    setMobileSideBar(!showMobileSideBar);
  };

  return (
    <div className="cr-flex cr-h-full cr-min-h-[calc(100vh)] cr-w-full cr-flex-col">
      <TopHeader
        toggleSideBar={toggleSideBar}
        toggleMobileSideBar={toggleMobileSideBar}
        showMobileSideBar={showMobileSideBar}
        signOut={signOut}
      />
      <div className="cr-relative cr-flex cr-h-full cr-w-full cr-flex-1 cr-flex-row cr-p-0">
        {/* Full Screen Version of Menu Bar */}
        <div className="cr-hidden sm:cr-block">
          <div
            className={`cr-top cr-fixed cr-h-full cr-w-48 cr-transition-transform cr-duration-700 ${showSideBar ? 'cr-translate-x-0' : 'cr--translate-x-full'}`}
          >
            <MenuBar />
          </div>
          <div className={`cr-flex-none cr-transition-all cr-duration-700 ${showSideBar ? 'cr-w-48' : 'cr-w-0'}`}></div>
        </div>

        {/* Mobile Version of Menu Bar */}
        <div className="cr-z-10 cr-block sm:cr-hidden">
          <div
            className={`cr-fixed cr-top-[88px] cr-h-full cr-w-full cr-transition-opacity cr-duration-300 ${showMobileSideBar ? 'cr-visible cr-opacity-100' : 'cr-invisible cr-opacity-0'}`}
          >
            <MenuBar setMobileSideBar={setMobileSideBar} />
          </div>
        </div>

        {/* Common wrapper for page content */}
        <div className="font-label cr-flex cr-w-full cr-flex-col" style={{ minWidth: 0 }}>
          <div
            className="cr-flex-1 cr-px-[2%] md:cr-px-[6%]"
            style={{ backgroundColor: 'var(--page-bg-color, transparent)', minWidth: 0 }}
          >
            <StatusBar />
            <Outlet />
          </div>
        </div>
      </div>
      <Toaster
        toastOptions={{
          className: 'cr-text-lg',
        }}
        containerStyle={{
          zIndex: 20000,
        }}
      />
    </div>
  );
}
